import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch("https://readdy.ai/api/form/d7np6m75qk5pqai6cutg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-16">
        <div className="max-w-6xl mx-auto px-6 py-16">
          {/* Header */}
          <div className="text-center mb-14">
            <span className="text-emerald-600 text-sm font-semibold uppercase tracking-widest">İletişim</span>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">
              Bizimle İletişime Geçin
            </h1>
            <p className="text-gray-500 max-w-xl mx-auto">
              Sorularınız, önerileriniz veya destek talepleriniz için bize ulaşın. En kısa sürede yanıt vereceğiz.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
            {/* Left Info */}
            <div className="lg:col-span-2 space-y-6">
              {[
                { icon: "ri-mail-line", title: "E-posta", value: "destek@qrgenerator.com", color: "bg-emerald-50 text-emerald-600" },
                { icon: "ri-phone-line", title: "Telefon", value: "+90 212 000 00 00", color: "bg-teal-50 text-teal-600" },
                { icon: "ri-map-pin-line", title: "Adres", value: "Levent, İstanbul, Türkiye", color: "bg-cyan-50 text-cyan-600" },
                { icon: "ri-time-line", title: "Çalışma Saatleri", value: "Pzt–Cum: 09:00–18:00", color: "bg-emerald-50 text-emerald-600" },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4 bg-white rounded-2xl border border-gray-100 p-5">
                  <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${item.color}`}>
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-gray-400 uppercase tracking-wide">{item.title}</div>
                    <div className="text-sm font-medium text-gray-800 mt-0.5">{item.value}</div>
                  </div>
                </div>
              ))}

              {/* Social */}
              <div className="bg-white rounded-2xl border border-gray-100 p-5">
                <div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Sosyal Medya</div>
                <div className="flex gap-3">
                  {[
                    { icon: "ri-twitter-x-line", label: "Twitter" },
                    { icon: "ri-instagram-line", label: "Instagram" },
                    { icon: "ri-linkedin-line", label: "LinkedIn" },
                  ].map((s) => (
                    <a
                      key={s.label}
                      href="#"
                      className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-50 hover:bg-emerald-50 hover:text-emerald-600 text-gray-500 transition-colors cursor-pointer"
                    >
                      <i className={`${s.icon} text-lg`}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Form */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-2xl border border-gray-100 p-8">
                {submitted ? (
                  <div className="flex flex-col items-center justify-center py-12 text-center">
                    <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-check-line text-3xl text-emerald-600"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Mesajınız İletildi!</h3>
                    <p className="text-gray-500 text-sm">En kısa sürede size geri döneceğiz.</p>
                    <button
                      onClick={() => setSubmitted(false)}
                      className="mt-6 px-6 py-2.5 bg-emerald-500 text-white text-sm font-semibold rounded-full hover:bg-emerald-600 transition-colors cursor-pointer"
                    >
                      Yeni Mesaj Gönder
                    </button>
                  </div>
                ) : (
                  <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1.5">Ad Soyad</label>
                        <input
                          type="text"
                          name="name"
                          required
                          placeholder="Adınız Soyadınız"
                          className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-emerald-400 transition-colors"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1.5">E-posta</label>
                        <input
                          type="email"
                          name="email"
                          required
                          placeholder="ornek@email.com"
                          className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-emerald-400 transition-colors"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Konu</label>
                      <input
                        type="text"
                        name="subject"
                        required
                        placeholder="Mesajınızın konusu"
                        className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-emerald-400 transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Mesaj</label>
                      <textarea
                        name="message"
                        required
                        rows={5}
                        maxLength={500}
                        placeholder="Mesajınızı buraya yazın..."
                        className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-emerald-400 transition-colors resize-none"
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={submitting}
                      className="w-full flex items-center justify-center gap-2 py-3 bg-emerald-500 hover:bg-emerald-600 disabled:opacity-60 text-white font-semibold rounded-xl transition-all cursor-pointer whitespace-nowrap"
                    >
                      {submitting ? (
                        <><i className="ri-loader-4-line animate-spin"></i> Gönderiliyor...</>
                      ) : (
                        <><i className="ri-send-plane-line"></i> Mesaj Gönder</>
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
